import { Asset } from "@server/types/redBeeTypes";
import { CmsAsset } from "../types/cms/CmsAssetType";
import { RedbeeFormattedAsset } from "@server/utils/transformers/assetTransformer";

/**
 * Get title from either RedBee Asset or RedbeeFormattedAsset Asset
 * @param asset - Asset object (RedBee or RedbeeFormattedAsset)
 * @param locales - Preferred locales in order of preference
 * @returns Title string
 */
export function getTitle(
  asset: Asset | RedbeeFormattedAsset | CmsAsset,
  locales: string[] = ["en"]
): string {
  let localization: { locale?: string; title?: string }[] | undefined =
    undefined;

  if ("localized" in asset) {
    localization = asset.localized;
  } else if ("localizedInfo" in asset) {
    localization = asset.localizedInfo;
  }

  if (localization) {
    const localizedWithTitles = localization.filter((loc: any) => loc.title);
    if (localizedWithTitles.length === 0) return "";

    const preferredLocalized = localizedWithTitles.filter((loc: any) =>
      locales.includes(loc.locale)
    );

    if (preferredLocalized.length === 0) {
      return localizedWithTitles[0].title || "Unknown title";
    }

    const sorted = preferredLocalized.sort(
      (a: any, b: any) => locales.indexOf(a.locale) - locales.indexOf(b.locale)
    );
    return sorted[0].title || "Unknown title";
  }

  return "";
}

export default {
  getTitle,
};
